import React from "react";
import { useAuth } from "../../Context/authContext";
import MentorEngagementDetail from "./MentorEngagementDetail";
import StudentEngagementDetail from "./StudentEngagementDetail";

const EngagementDetail = () => {
  const { user } = useAuth();

  // Route to appropriate component based on user role
  if (user?.role === 'mentor') {
    return <MentorEngagementDetail />;
  }

  if (user?.role === 'admin') {
    return <MentorEngagementDetail isReadOnly />;
  }

  // Student: same layout, but Review & Scores is read-only
  return <MentorEngagementDetail reviewReadOnly />;
};

export default EngagementDetail;

